import React, { useEffect } from "react";
import { Card, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import agentConsoleImage from '../Assets/Icons/agentconsle.avif';
import reportPortalImage from '../Assets/Icons/reportportal.avif';
import recordingPortalImage from '../Assets/Icons/recordingportal.avif';
import realTimeDashboardImage from '../Assets/Icons/realtimedashboread.avif';
import "./CSS/HomeComponent.css";

// Console agent (Unify). Elle vit sur son propre domaine, hors du portail : l'URL ne peut
// donc pas être relative comme les liens internes. Sortie en constante nommée plutôt
// qu'enfouie dans un handler de clic, pour être trouvable.
const AGENT_CONSOLE_URL = "https://unify.heedify.io";

const HomeComponent = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // Onboarding : tenant neuf non consenti (cf. ONBOARDING_BOOTSTRAP_MODE.md)
  const bootstrapMode = useSelector((s) => s.reducer.bootstrapMode);

  // Tenant neuf non consenti → on envoie directement sur la page de consent.
  // Chemin RELATIF → /globalSettings sur l'origine courante (portal.heedify.io en prod,
  // localhost:3000 en local, QA…). Pas d'URL en dur pour ne pas casser local/QA.
  useEffect(() => {
    if (bootstrapMode) {
      navigate("/globalSettings", { replace: true });
    }
  }, [bootstrapMode, navigate]);

  let timeOfDay;
  const date = new Date();
  const hours = date.getHours();
  let greetingColor;

  if (hours < 12) {
    timeOfDay = t("GOOD_MORNING");
    greetingColor = "#D90000";
  } else if (hours >= 12 && hours < 17) {
    timeOfDay = t("GOOD_AFTERNOON");
    greetingColor = "#04733F";
  } else {
    timeOfDay = t("GOOD_EVENING");
    greetingColor = "#04756F";
  }

  return (
    <div className="home-container">
      <h1 className="home-title">{t("HOME_GREETING")}</h1>
      <span className="home-page-greeting" style={{ color: greetingColor }}>
        {timeOfDay}
      </span>
      <p className="home-message">{t("HOME_MESSAGE")}</p>

      <div className="home-cards-container">
        <Card
          className="home-card"
          onClick={() => {
            // Console agent Unify. Pointait auparavant sur https://agentconsole.heedify.io
            // (l'ancienne console) — deux hôtes bien distincts, tous deux encore en ligne.
            window.open(AGENT_CONSOLE_URL, "_blank");
          }}
        >
          <div className="home-card-body">
            <div className="home-card-image-container">
              <img src={agentConsoleImage} alt="Agent Console" className="home-card-image " />
            </div>
            <Text className="home-card-name">{t("AGENT_CONSOLE")}</Text>
          </div>
        </Card>

      </div>
    </div>
  );
};

export default HomeComponent;